import React from 'react'

interface ThirdCardProps {
  card: any
}

export function ThirdCard({ card }: ThirdCardProps) {
  if (!card) return null

  const title = card.title
  // Supondo que card.Button é um array de cards, cada um com title e description
  const items = Array.isArray(card.Button) ? card.Button : []

  return (
    <section
      style={{
        width: '100%',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(40px, 8vw, 80px) clamp(12px, 4vw, 32px) 0',
        minHeight: 'clamp(320px, 50vh, 480px)',
        boxSizing: 'border-box',
        fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}
    >
      {/* Título centralizado */}
      <h2
        style={{
          fontSize: 'clamp(22px, 5vw, 36px)',
          fontWeight: 700,
          color: '#111',
          textAlign: 'center',
          marginBottom: 'clamp(32px, 6vw, 56px)',
          maxWidth: 900,
          lineHeight: 1.2,
          letterSpacing: 0.5
        }}
      >
        {title}
      </h2>
      {/* Grid de cards responsivo */}
      <div
        className="third-card-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 'clamp(16px, 4vw, 36px)',
          width: '100%',
          maxWidth: 1400,
        }}
      >
        {items.map((item: any, idx: number) => (
          <div
            key={idx}
            style={{
              background: '#f4f7f9',
              borderRadius: 20,
              boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
              padding: 'clamp(20px, 4vw, 36px) clamp(16px, 3vw, 32px)',
              minHeight: 160,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              wordBreak: 'break-word',
            }}
          >
            <div style={{ fontSize: 'clamp(18px, 3vw, 26px)', fontWeight: 700, color: '#222', marginBottom: 16, letterSpacing: 1, textAlign: 'left' }}>{item.title}</div>
            <div style={{ fontSize: 'clamp(14px, 2vw, 18px)', color: '#444', lineHeight: 1.5, letterSpacing: 0.5, textAlign: 'left' }}>{item.description}</div>
          </div>
        ))}
      </div>
      <style>{`
        @media (max-width: 900px) {
          .third-card-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  )
} 